import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  AirModeIcon,
  FclModeIcon,
  FtlModeIcon,
  LclModeIcon,
  LtlModeIcon,
  OceanModeIcon,
  PurpleDomesticTruckIcon,
  InlandPrimaryIcon,
} from '../icons/icons';
import Tooltip from '../tooltip/tooltip';
import './shipment-mode.scss';
import { getEnglishMode } from '../../helpers/utils';

/**
 * @typedef {'left' | 'center' | 'right'} AlignType - Size choices for the Demo component.
 */

/**
 * Component to demonstrate different sizes, appearances, and popup options.
 * @param {Object} props
 * @param {AlignType} props.align
 * @returns {JSX.Element}
 */

export default function ShipmentMode({
  shipmentMode,
  multipleMode,
  endShipment,
  startShipment,
  startShipmentMode,
  endShipmentMode,
  bookingType,
  align,
}) {
  const [t] = useTranslation('manageorders');
  const mode = getEnglishMode(shipmentMode);
  const startMode = getEnglishMode(startShipmentMode);
  const endMode = getEnglishMode(endShipmentMode);

  const alignProperties = {
    left: 'left',
    center: 'center',
    right: 'right',
  };
  const alignProps = alignProperties[align];
  return (
    <div className={`mode-icon${` ${alignProps}`}`}>
      {!multipleMode ? (
        <Tooltip
          content={t(
            `manageordersscreen.filterbtn.secredOptions.${shipmentMode}${
              bookingType ? ` ${bookingType}` : ''
            }`
          )}
          direction="right"
        >
          {/* <Tooltip content={`${mode}`} direction="right"> */}
          {mode === 'Ocean' && <OceanModeIcon size="2.778vw" />}
          {mode === 'Air' && <AirModeIcon size="2.778vw" />}
          {mode === 'FCL' && <FclModeIcon size="2.778vw" />}
          {mode === 'FTL' && <FtlModeIcon size="2.778vw" />}
          {mode === 'LTL' && <LtlModeIcon size="2.778vw" />}
          {mode === 'LCL' && <LclModeIcon size="2.778vw" />}
          {/* {mode === 'Inland' && <LtlModeIcon size="30" />} */}
          {mode === 'Inland' && bookingType === 'Pickup' && (
            <LtlModeIcon size="2.778vw" />
          )}
          {mode === 'Inland' && bookingType === 'Delivery' && (
            <PurpleDomesticTruckIcon size="2.778vw" />
          )}
          {mode === 'Inland' &&
            (bookingType === 'Primary' || bookingType === 'consolidated') && (
              <InlandPrimaryIcon size="2.778vw" />
            )}
          {mode === 'Inland' && (!bookingType || bookingType === '') && (
            <InlandPrimaryIcon size="2.778vw" /> // Adding this line for ata inland shipments when their is no bookingtype
          )}
          {mode === 'Road' && (!bookingType || bookingType === '') && (
            <InlandPrimaryIcon size="2.778vw" /> // Adding this line for ata inland shipments when their is no bookingtype
          )}
        </Tooltip>
      ) : (
        <div className="multiple-mode">
          {startShipment && (
            <Tooltip direction="top" content={`By ${startMode}`}>
              <span className="mode-block">
                <span className="mode-text">{startShipment}</span>
                <span className="icon">
                  {startMode === 'Ocean' && <OceanModeIcon />}
                  {startMode === 'Air' && <AirModeIcon />}
                  {startMode === 'FCL' && <FclModeIcon />}
                  {startMode === 'FTL' && <FtlModeIcon />}
                  {(startMode === 'LTL' || startMode === 'Inland') && (
                    <LtlModeIcon />
                  )}
                  {startMode === 'LCL' && <LclModeIcon />}
                </span>
              </span>
            </Tooltip>
          )}
          {endShipment && (
            <Tooltip direction="top" content={`By ${endMode}`}>
              <span className="mode-block">
                <span className="mode-text">{endShipment}</span>
                <span className="icon">
                  {endMode === 'Ocean' && <OceanModeIcon />}
                  {endMode === 'Air' && <AirModeIcon />}
                  {endMode === 'FCL' && <FclModeIcon />}
                  {endMode === 'FTL' && <FtlModeIcon />}
                  {(endMode === 'LTL' || endMode === 'Inland') && (
                    <LtlModeIcon />
                  )}
                  {endMode === 'LCL' && <LclModeIcon />}
                </span>
              </span>
            </Tooltip>
          )}
        </div>
      )}
    </div>
  );
}
ShipmentMode.propTypes = {
  shipmentMode: PropTypes.string,
  multipleMode: PropTypes.bool,
  endShipment: PropTypes.string,
  startShipment: PropTypes.string,
  startShipmentMode: PropTypes.string,
  endShipmentMode: PropTypes.string,
  bookingType: PropTypes.string,
  align: PropTypes.string,
};
ShipmentMode.defaultProps = {
  shipmentMode: '',
  multipleMode: false,
  endShipment: '',
  startShipment: '',
  startShipmentMode: '',
  endShipmentMode: '',
  bookingType: '',
  align: '',
};
